"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Edit = void 0;
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const react_1 = __importDefault(require("react"));
const Edit = ({ onClick, customText = null, red = false, green = false, ico = _ui_1.Icon.ICONS.edit, disabled = false, testid, }) => {
    return (react_1.default.createElement(_ui_1.Button, { testid: testid, color: red ? _ui_1.Button.COLORS.RED : green ? _ui_1.Button.COLORS.GREEN : _ui_1.Button.COLORS.PRIMARY, onClick: onClick, disabled: disabled, ico: ico, label: customText || (0, i18n_1.t)('EDIT') }));
};
exports.Edit = Edit;
